import { H1Text } from "../../../../../design";
import React from "react";
import { AmountDivideByHundred } from "../../../../../helper";
import { TAX_RATE_TYPES } from "../../../../../appconstants";
import currencyFormatter from "../../../../../utils/currencyformatter";
import SmallScreenView from "../../../../../components/smallscreen";

type Props = {
  invoices: Array,
  currency: Object,
  invoice: Object,
}

const InvoiceLineItemMobile = (props: Props) => {
  const { invoices, currency, invoice } = props;

  const getTotalAmount = () => {
    return invoice && invoice.total;
  };

  const getDiscountOff = (value) => {
    let discountOff;
    const months = value && value.validiyInMonths;
    if (months && value.percentageOff) {
      discountOff = `${value.percentageOff}% off for ${months} months`;
    } else if (!months && value.percentageOff) {
      discountOff = `${value.percentageOff}% off ${value.validity}`;
    } else if (months && value.amountOff) {
      discountOff = `${value.amountOff / 100} off for ${months} months`;
    } else if (!months && value.amountOff) {
      discountOff = `${value.amountOff / 100} off ${value.validity}`;
    }
    return discountOff;
  };

  const getAmountOff = (value) => {
    let amountOff;
    if (value && value.percentageOff) {
      const amount = AmountDivideByHundred(invoice && invoice.amount * value.percentageOff);
      amountOff = currency && currencyFormatter((AmountDivideByHundred(amount)), currency.name);
    } else if (value && value.amountOff) {
      amountOff = currency && currencyFormatter(AmountDivideByHundred(value.amountOff), currency.name);
    }
    return amountOff;
  };

  return (
    <SmallScreenView sm xs>
      <div className="row mt-4">
        <div className="table-responsive invoice">
          <table className="table text-left table-borderless">
            <tr style={{ background: "#eeeeff", borderRadius: "3px !important" }}>
              <th colSpan="3" borderRadius="3px 0 0 3px" className="border-0 w-50">
                <span className="m-0">Description</span>
              </th>
               <th className="text-center border-0">
                <span className="m-0">Quantity</span>
              </th>
              <th className="text-center border-0">
                <span className="m-0 text-center">Rate</span>
              </th>
              <th className="text-center border-0">
                <span className="m-0 text-center">Total</span>
              </th>
            </tr>
            <tbody>
              {
                invoices && invoices.map((value, index) => (
                  <tr className="border-0" key={index}>
                    <td colSpan="3" className="border-0">
                      <span color="#1a1a1a" fontWeight="400" className="m-0">{value.name}</span>
                    </td>
                    <td className="text-center border-0">
                      <span color="#1a1a1a" fontWeight="400" className="m-0">
                        {value.quantity}
                      </span>
                    </td>
                    <td className="text-center border-0">
                      <span color="#000000" fontWeight="400" className="m-0 text-center">
                        {value.amount && currency && currencyFormatter(AmountDivideByHundred(value.amount), currency.name)}
                      </span>
                    </td>
                    <td className="text-center border-0">
                      <span color="#000000" fontWeight="400" className="m-0 text-center">
                        {value.amount && value.quantity && currency && currencyFormatter(AmountDivideByHundred(value.amount * value.quantity), currency.name)}
                      </span>
                    </td>
                  </tr>
                ))
              }
              <tr className="border-top font-weight-bold">
                <td colSpan="3" className="border-0">
                </td>
                <td className="border-0">
                </td>
                <td className="text-center border-0">
                  <span color="#1a1a1a" fontWeight="600" className="mr-4">Subtotal</span>
                </td>
                <td className="text-center border-0">
                {invoice && invoice.amount && currency && currencyFormatter(AmountDivideByHundred(invoice.amount), currency.name)}
                </td>
              </tr>
              <tr className="border-top" />
              {
                invoice && invoice.coupon && invoice.coupon.name && (
                  <>
                    <tr className="border-0">
                      <td colSpan="3" className="text-left border-0 w-50">
                        <span color="#000000" fontWeight="400" className="m-0 text-left">
                          {invoice.coupon.name} <br />
                          <span style={{ fontSize: '12px' }}>{getDiscountOff(invoice.coupon)}</span>
                        </span>
                      </td>
                      <td className="border-0" />
                      <td className="text-center border-0">
                        <span color="#000000" fontWeight="400" className="m-0 text-right">
                          ({getAmountOff(invoice.coupon)})
                        </span>
                      </td>
                    </tr>
                    <tr style={{ borderTop: '1px solid #dee2e6' }} />
                  </>
                )
              }
              {
                invoice && invoice.taxAmount && invoice.taxAmount.map((value, index) => (
                  <tr className="border-0" key={index}>
                    <td colSpan="3" className="text-left border-0 w-50">
                      <span color="#000000" fontWeight="400" className="-0 text-left">
                        {value.taxRates.displayName} <br />
                        <span style={{ fontSize: '12px' }}>{value.taxRates.inclusive ? TAX_RATE_TYPES.INCLUSIVE : TAX_RATE_TYPES.EXCLUSIVE}</span>
                      </span>
                    </td>
                    <td className="text-center border-0">
                      <span color="#000000" fontWeight="400" className="m-0  text-center">
                        {value.taxRates.percentage} %
                      </span>
                    </td>
                    <td colSpan="2" className="text-center border-0">
                      <span color="#000000" fontWeight="400" className="m-0 text-right">
                        {currency && currencyFormatter(AmountDivideByHundred(value.tax), currency.name)}
                      </span>
                    </td>
                  </tr>
                ))
              }
            </tbody>
            <tfoot className="text-right invoice-table-foot border-top">
              {invoice?.invoiceType === "PARTIAL" && invoice?.lateFeeAmount &&
                (
                  <tr>
                    <td colSpan="7" className="text-right border-0">
                      <H1Text fontWeight="600" fontSize="14px" className="m-0 text-right">Late Fee Amount (+)&nbsp;&nbsp;&nbsp;&nbsp;
                        {currency && currencyFormatter(AmountDivideByHundred(invoice.lateFeeAmount) , currency.name)}
                      </H1Text>
                    </td>
                  </tr>
                )
              }
              {invoice?.invoiceType === "PARTIAL" && invoice?.overdueInterestAmount &&
                (
                  <tr>
                    <td colSpan="7" className="text-right border-0">
                      <H1Text fontWeight="600" fontSize="14px" className="m-0 text-right">Overdue Interest Amount (+)&nbsp;&nbsp;&nbsp;&nbsp;
                        {currency && currencyFormatter(AmountDivideByHundred(invoice.overdueInterestAmount) , currency.name)}
                      </H1Text>
                    </td>
                  </tr>
                )
              }
              <tr>
                <td colSpan="7" className="text-right border-0">
                  <H1Text fontWeight="600" fontSize="14px" className="m-0 text-right">Total Amount&nbsp;&nbsp;&nbsp;&nbsp;
                    {currency && currencyFormatter(AmountDivideByHundred(getTotalAmount()), currency.name)}
                  </H1Text>
                </td>
              </tr>
              {invoice?.invoiceType === "PARTIAL" && invoice?.paidAmount &&
                (
                  <tr>
                    <td colSpan="7" className="text-right border-0">
                      <H1Text fontWeight="600" fontSize="14px" className="m-0 text-right">Paid Amount (-)&nbsp;&nbsp;&nbsp;&nbsp;
                        {currency && currencyFormatter(AmountDivideByHundred(invoice.paidAmount) , currency.name)}
                      </H1Text>
                    </td>
                  </tr>
                )
              }
              {invoice?.invoiceType === "PARTIAL" && invoice?.paidAmount &&
                (
                  <tr>
                    <td colSpan="7" className="text-right border-0">
                      <H1Text fontWeight="600" fontSize="14px" className="m-0 text-right">Remaining Amount&nbsp;&nbsp;&nbsp;&nbsp;
                        {currency && currencyFormatter(AmountDivideByHundred(getTotalAmount() - invoice.paidAmount) , currency.name)}
                      </H1Text>
                    </td>
                  </tr>
                )
              }
            </tfoot>
          </table>
        </div>
      </div>
    </SmallScreenView>
  )
}

export default InvoiceLineItemMobile
